<!-- 
    参数格式

list        非必填          [{name:展示名称,type:跳转路由}]

bgColor     非必填          "#ff"  -   背景颜色

<slot name="logo-wrap">     插槽 控制logo 和 tab
<slot name="tab-wrap">

-->

<template>
  <div class="header-content" v-if="!isMobile">
    <div class="main">
      <div class="logo-content">
        <div class="logo-container">
          <img
            src="@/assets/images/icon-40.png"
            alt=""
            class="logo-image-left"
          />
          <img
            src="@/assets/images/icon-34.png"
            alt=""
            class="logo-image-right"
          />
        </div>
        <!-- <img src="@/assets/images/icon-29.png" alt="" class="logo-image"> -->
        <!-- <img class="logo-image" :src="$globalHeader.fileUrl + '/static/fjtwfw/logo_mini.png'" alt="logo" /> -->
        <!-- <div class="name-column"> -->
        <!-- <div class="name-title">高质量就业服务提供商</div> -->
        <!-- <div class="line-text">
            <span></span>
            <div>高质量就业服务提供商</div>
            <span></span>
          </div> -->
        <!-- </div> -->
        <div class="search-column">
          <div class="search-row">
            <el-input
              v-model="searchKey"
              type="text"
              class="input"
              style="width: 263px"
              placeholder="请输入关键字"
            ></el-input>
            <div class="search-btn" @click="searchChange">
              <i class="el-icon-search search-img"></i>
              <div class="text">搜索</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 菜单 -->
    <div class="menu">
      <div class="menu-content">
        <div
          class="menu-item"
          v-for="(item, index) in navList"
          :key="index"
          @click="handleEnter(item, item.categoryCode, 1)"
        >
          {{ item.categoryName }}

          <!-- <i v-if="item.list" class="el-icon-arrow-down el-icon--right"></i> -->
          <div class="hr" v-if="currentMenu == item.categoryCode"></div>
          <ul class="submenu">
            <li
              v-for="(t, i) in item.list"
              :key="i"
              @click.stop="handleEnter(t, item.categoryCode, 3)"
              class="sub-item"
            >
              {{ t.categoryName }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="mobile-header">
      <div class="mobile-logo">
        <div class="logo-container">
          <img
            src="@/assets/images/icon-40.png"
            alt=""
            class="logo-image-left"
          />
          <img
            src="@/assets/images/icon-34.png"
            alt=""
            class="logo-image-right"
          />
        </div>
        <!-- <img src="@/assets/images/icon-29.png" alt="" class="logo-img" /> -->
        <!-- <img class="logo-img" :src="$globalHeader.fileUrl + '/static/fjtwfw/logo_mini.png'" alt="" /> -->
        <!-- <div class="logo-column"> -->
        <!-- <div class="title">高质量就业服务提供商</div> -->
        <!-- <div class="message">
            <span></span>
            <div>高质量就业服务提供商</div>
            <span></span>
          </div> -->
        <!-- </div> -->
      </div>
      <div class="mobile-flex-auto"></div>
      <div class="mobile-btn" @click="onShowClick">
        <img
          v-if="!mobileShow"
          src="@/assets/images/mobile-1.png"
          class="image"
          alt=""
        />
        <img
          v-if="mobileShow"
          src="@/assets/images/mobile-22.png"
          class="image"
          alt=""
        />
      </div>
    </div>
    <div
      class="mobile-fixed"
      :class="mobileShow ? 'mobile-fixed-active' : ''"
      @click="onShowClick"
    >
      <div class="mobile-menu" @click.stop>
        <div
          class="menu-box"
          v-for="(item, index) in navList"
          :key="index"
          @click.stop="handleMobileEnter(item, item.categoryCode, 1)"
        >
          <div
            class="menu-nav"
            :class="currentMenu == item.categoryCode ? 'menu-nav-active' : ''"
          >
            <div class="text">{{ item.categoryName }}</div>
            <div class="back" v-if="item.list && item.list?.length != 0">
              <img src="@/assets/images/icon-7.png" alt="" class="image" />
            </div>
          </div>
          <div
            class="menu-child"
            v-if="
              item.list &&
              item.list.length != 0 &&
              currentMenu == item.categoryCode
            "
          >
            <div
              class="child-item"
              v-for="(t, i) in item.list"
              :key="i"
              @click.stop="handleChildMobileEnter(t, item.categoryCode, 2)"
            >
              - {{ t.categoryName }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNavList } from '@/api/common/common'
import { mapState } from 'vuex'
export default {
  props: ['list', 'currentIndex', 'splitLine', 'keyWord'],
  data() {
    return {
      searchKey: '', //搜索内容
      navList: [], // 导航列表
      currentMenu: '', // 获取当前路由
      mobileShow: false // 移动端显示
    }
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile // 假设 isMobile 在根 state 下
    })
  },
  watch: {
    $route: {
      handler(to) {
        // 路由变化时执行
        this.currentMenu = to.meta.type
      },
      immediate: true // 立即执行一次
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    chooseTab(item) {
      if (item.type == 'home') {
        this.$router.push('/')
      } else {
        if (item.type && typeof item.type == 'string') {
          //  this.$router.replace("/" + item.type);
          window.location.href = '/' + item.type
        }
      }
    },
    searchChange() {
      if (!this.searchKey || this.searchKey == '') return
      //搜索结果页面
      this.$router.push({
        path: '/searchPage/searchResult',
        query: {
          keyWord: this.searchKey
        }
      })
    },
    fetchData() {
      this.searchKey = this.word
      getNavList({ websiteType: 1 }).then((res) => {
        this.navList = res.data
        
        // 修复技能提升的 linkType 为 5
        this.navList.forEach(navItem => {
          if (navItem.list) {
            const skillItem = navItem.list.find(item => item.categoryName === '技能提升')
            if (skillItem) {
              skillItem.linkType = '5'
            }
          }
        })
      })
    },
    handleEnter(item, tabcode, typeIndex) {
      if (item.list && typeIndex == 1) {
        item = item.list[0]
      }

      if (item.linkUrl == 'home') {
        this.$router.push('/')
      } else {
        // 修复媒体报道的跳转
        if (item.categoryName === '媒体报道') {
          // 直接跳转到媒体报道页面
          this.$router.push({
            path: '/imageText',
            query: {
              categoryId: '209',
              linkType: '3',
              tabcode: tabcode,
              seccode: '209'
            }
          })
          return
        }
        
        let categoryCode = item.categoryCode
        let baseUrl =
          '?categoryId=' +
          categoryCode +
          '&linkType=' +
          item.linkType +
          '&tabcode=' +
          tabcode +
          '&seccode=' +
          item.categoryCode
        let url = ''
        // 实训基地   基地介绍   实训资源
        if (['123', '130'].indexOf(item.categoryCode) != -1) {
          url = '/base/introduction' + baseUrl
          url =
            item.linkUrl || item.url != null ? url + '&id=' + item.linkUrl : url
          this.$router.push(url)
          return
        }

        // 实训项目
        if (['202'].indexOf(item.categoryCode) != -1) {
          url = '/base/project' + baseUrl
          url =
            item.linkUrl || item.url != null ? url + '&id=' + item.linkUrl : url
          this.$router.push(url)
          return
        }
        //师资队伍
        if (['132'].indexOf(item.categoryCode) != -1) {
          url = '/base/faculty' + baseUrl
          url =
            item.linkUrl || item.url != null ? url + '&id=' + item.linkUrl : url
          this.$router.push(url)
          return
        }

        //线上课程
        if (['134'].indexOf(item.categoryCode) != -1) {
          url = '/base/course' + baseUrl
          url =
            item.linkUrl || item.url != null ? url + '&id=' + item.linkUrl : url
          this.$router.push(url)
          return
        }
        // 协同育人模块
        if (['139', '140', '141'].indexOf(item.categoryCode) != -1) {
          url = '/collaboration' + baseUrl
          url =
            item.linkUrl || item.url != null ? url + '&id=' + item.linkUrl : url
          this.$router.push(url)
          return
        }

        if (item.linkType == '7') {
          window.open(item.linkUrl)
        } else {
          switch (item.linkType) {
            case '1':
              url = '/article' + baseUrl
              break
            case '2':
              url = '/singleImage' + baseUrl
              break
            case '3':
              url = '/imageText' + baseUrl
              break
            case '5':
              url = '/tabList' + baseUrl
              break
            case '8':
              url = '/coopPartner' + baseUrl
              break
            case '9':
              url = '/contactUs' + baseUrl
              break

            default:
              baseUrl
          }
          url =
            item.linkUrl || item.url != null ? url + '&id=' + item.linkUrl : url
          this.$router.push(url)

          // window.location.href = url
        }
      }
    },
    onShowClick() {
      this.mobileShow = !this.mobileShow
    },
    handleMobileEnter(item, tabcode, typeIndex) {
      if (item.linkUrl == 'home') {
        this.$router.push('/')
        this.onShowClick()
        return
      }
      if (item.list) {
        this.currentMenu =
          this.currentMenu == item.categoryCode ? '' : item.categoryCode
        return
      }
      this.handleEnter(item, tabcode, typeIndex)
      this.onShowClick()
    },
    handleChildMobileEnter(item, tabcode, index) {
      this.onShowClick()
      this.handleEnter(item, tabcode, index)
    }
  }
}
</script>

<style lang="scss" scoped>
.header-content {
  background-color: #fff;
  position: fixed;
  top: 0;
  z-index: 100000;
  width: 100%;
  height: 197px;
  display: flex;
  flex-direction: column;

  .menu {
    display: flex;
    flex-direction: row;
    background: #1b56a9;
    height: 54px;

    .menu-content {
      width: 1340px;
      margin: 0 auto;
      display: flex;
      flex-direction: row;

      .menu-item {
        width: 192px;
        color: #fff;
        font-size: 24px;
        font-weight: 600;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        position: relative;

        .hr {
          position: absolute;
          width: 48px;
          height: 2.5px;
          bottom: 0;
          left: 0;
          right: 0;
          margin: 0 auto;
          border-radius: 20px 20px 0 0;
          background: #fff;
        }

        .submenu {
          position: absolute;
          top: 54px;
          // max-height: 0;
          display: none;
          overflow: hidden;
          width: 192px;
          margin: 0 auto;
          padding: 0;
          left: 0;
          right: 0;
          text-align: center;
          border-radius: 0 0 16px 16px;
          background: #e9eef6;
          // display: flex;
          flex-direction: column;

          .sub-item {
            height: 54px;
            line-height: 54px;
            border-top: 0.7px solid #fff;
            color: #111;
            font-size: 20px;
            font-weight: 400;
          }
        }
      }

      .menu-item:hover {
        background: #e9eef6;
        color: #1b56a9;

        .submenu {
          min-height: fit-content;
          display: flex;

          .sub-item:hover {
            color: #1b56a9;
          }
        }
      }
    }
  }

  .main {
    display: flex;
    flex-direction: column;
    width: 1340px;
    margin: 0 auto;

    .logo-content {
        display: flex;
        flex-direction: row;
        height: 95px;
        margin: 24px 0;

      .search-column {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .search-row {
          display: flex;
          flex-direction: row;
          justify-content: flex-end;

          ::v-deep .el-input__inner {
            border-radius: 0;
          }

          .search-btn {
            width: 103px;
            height: 40px;
            line-height: 40px;
            background: #1b56a9;
            display: flex;
            flex-direction: row;
            justify-content: center;
            color: #fff;
            cursor: pointer;

            .search-img {
              margin: auto 0;
              font-size: 16px;
            }

            .text {
              font-size: 16px;
              margin-left: 8px;
            }
          }
        }
      }

      .name-column {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 34px;

        .line-text {
          display: flex;
          flex-direction: row;
          justify-content: center;
          color: #1b56a9;
          position: relative;
          top: -4px;

          span {
            width: 56px;
            height: 1.5px;
            background-color: #1b56a9;
            /* 可换成你想要的颜色 */
            margin: auto 24px;
          }

          div {
            white-space: nowrap;
            font-weight: 500;
            font-size: 10px;
            /* 可根据需要调整 */
            font-size: 22px;
          }
        }

        .name-title {
          color: #1b56a9;
          font-size: 46px;
          font-weight: 600;
        }
      }
      .logo-container {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      .logo-image-left {
        width: 240px;
        height: 95px;
        object-fit: contain;
      }
      .logo-image-right {
        width: 505px;
        height: 45px;
        object-fit: contain;
        margin-left: 110px;
      }
      .logo-image {
        width: 87px;
        height: 99px;
        object-fit: contain;
      }
    }
  }
}

// 手机端css
.mobile-content {
  .mobile-header {
    width: 375px;
    height: 60px;
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 9999;
    display: flex;
    flex-direction: row;
    box-shadow: -3px -7px 9.1px -4px rgba(0, 0, 0, 0.02),
      0 10px 15px -3px rgba(0, 0, 0, 0.03);

    .mobile-btn {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-right: 15px;

      .image {
        width: 23px;
        height: 18px;
        margin: auto 0;
        object-fit: contain;
      }
    }

    .mobile-flex-auto {
      display: flex;
      flex: 1;
    }

    .mobile-logo {
      display: flex;
      flex-direction: row;
      margin: auto 0;

      .logo-column {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 10px;

        .message {
          height: 12px;
          line-height: 12px;
          color: #005bac;
          font-size: 12px;
          font-weight: 500;
          margin-top: 5px;
          text-align: left;
          display: flex;
          flex-direction: row;
          justify-content: center;

          span {
            width: 22px;
            height: 0.7px;
            background-color: #1b56a9;
            /* 可换成你想要的颜色 */
            margin: auto 10px;
          }
        }

        .title {
          height: 16px;
          line-height: 16px;
          color: #005bac;
          font-size: 17px;
          font-weight: bold;
          text-align: left;
        }
      }
      .logo-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 5px;
      }
      .logo-image-left {
        width: 100px;
        height: 50px;
        object-fit: contain;
      }
      .logo-image-right {
        width: 200px;
        height: 25px;
        object-fit: contain;
        margin-left: 24px;
      }
      .logo-img {
        width: 60px;
        height: 40px;
        object-fit: contain;
        margin-left: 5px;
      }
    }
  }

  // 导航菜单
  .mobile-fixed-active {
    left: 0 !important;
  }

  .mobile-fixed {
    display: flex;
    flex-direction: column;
    position: fixed;
    text-align: right;
    width: 100%;
    height: 100%;
    left: 100%;
    top: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 98;
    transition: all 0.3s ease-in-out;
    z-index: 9998;

    .mobile-menu {
      display: flex;
      flex-direction: column;
      background: #fff;
      width: 215px;
      padding: 28px 24px 0;
      margin-top: 60px;
      margin-left: auto;
      height: calc(100% - 60px);
      gap: 15px;
      overflow-x: hidden;
      overflow-y: auto;

      .menu-box {
        // min-height: 30px;
        display: flex;
        flex-direction: column;

        // border-bottom: 1px solid #e6e6e6;
        .active {
          .text {
            color: #005bac !important;
          }

          .back {
            color: #005bac !important;
          }
        }

        .menu-child {
          display: flex;
          flex-direction: column;
          text-align: left;
          gap: 15px;
          margin-top: 15px;

          .child-item {
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            margin-left: 15px;
          }
        }

        .menu-nav {
          height: 30px;
          line-height: 30px;
          display: flex;
          flex-direction: row;

          .back {
            width: 30px;
            height: 30px;

            .image {
              width: 15px;
              height: 15px;
            }
          }

          .text {
            color: #333;
            font-size: 15px;
            font-weight: 500;
            flex: 1;
            text-align: left;
          }
        }

        .menu-nav-active {
          .text {
            color: #1b56a9;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
